// client/src/services/controlPlaneService.js
/**
 * Service « Connexion au central » — réglage local du serveur (agent de site).
 * Réservé admin/manager. Le token n'est jamais renvoyé (statut = hasToken).
 * @author Dr Hamid MADANI <drmdh@msn.com>
 */
import axios from 'axios';

const API_URL = '/api/control-plane';

const controlPlaneService = {
  /** { enabled, url, siteId, hasToken, connected, lastError } */
  get: async () => (await axios.get(API_URL)).data.data,
  /** Enregistre url/siteId/token/enabled puis (re)connecte. */
  save: async (patch) => (await axios.put(API_URL, patch)).data.data,
  /** Coupe et désactive la connexion. */
  disconnect: async () => (await axios.post(`${API_URL}/disconnect`)).data.data,
};

export default controlPlaneService;
